
import React from 'react';
import MaintenanceParameter from '../MaintenanceParameter';
import { Device } from '@/components/device-health/gis-map/types';

export interface MaintenanceParameterData {
  title: string;
  description: string;
  icon: React.ReactNode;
  bgClass: string;
  status: string;
  lastUpdated: string;
  deviceId?: string; // Added deviceId to associate with specific devices
}

interface MaintenanceParametersListProps {
  parameters: MaintenanceParameterData[];
  selectedDeviceId?: string;
  deviceData?: Device | null;
  assetTypeFilter?: string | null;
  facilityFilter?: string | null;
}

const MaintenanceParametersList = ({ 
  parameters, 
  selectedDeviceId, 
  deviceData,
  assetTypeFilter,
  facilityFilter 
}: MaintenanceParametersListProps) => {
  // Filter parameters if a specific device is selected
  const filteredParameters = selectedDeviceId
    ? parameters.filter(param => !param.deviceId || param.deviceId === selectedDeviceId)
    : parameters;
  
  // Customize title based on selected device
  const getTitle = (title: string) => {
    if (deviceData && selectedDeviceId) {
      // Add device name to the title
      return `${title} - ${deviceData.name}`;
    }
    return title;
  };
  
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      {filteredParameters.length > 0 ? (
        filteredParameters.map((param, index) => (
          <MaintenanceParameter 
            key={index}
            index={index}
            title={getTitle(param.title)}
            description={param.description}
            icon={param.icon}
            bgClass={param.bgClass}
            status={param.status}
            lastUpdated={param.lastUpdated}
          />
        ))
      ) : (
        <div className="col-span-3 p-6 text-center border rounded-lg">
          <p className="text-muted-foreground">No maintenance parameters found for this device</p>
        </div>
      )}
    </div>
  );
};

export default MaintenanceParametersList;
